import { apiSlice } from '../../../api/common/apiSlice';
import { ApiTagType } from '../../../constants/apiTagType';
import {
  BankLookup,
  CreateBankLookupRequest,
  FetchBankLookupsRequest,
  UpdateBankLookupRequest,
} from '../../../types/bankLookup';

const BANK_LOOKUP_URL = '/admin/bank-lookup';

export const bankLookupApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchBankLookups: builder.query<BankLookup[], FetchBankLookupsRequest | void>({
      query: (params) => ({ url: BANK_LOOKUP_URL, method: 'GET', params: params || undefined }),
      providesTags: (res) => [
        ...(res || []).map(({ id }) => ({ type: ApiTagType.BankLookup as const, id })),
        { type: ApiTagType.BankLookup, id: 'LIST' },
      ],
    }),
    createBankLookup: builder.mutation<BankLookup, CreateBankLookupRequest>({
      query: (data) => ({ url: BANK_LOOKUP_URL, method: 'POST', body: data }),
      invalidatesTags: [{ type: ApiTagType.BankLookup, id: 'LIST' }],
    }),
    updateBankLookup: builder.mutation<BankLookup, UpdateBankLookupRequest>({
      query: ({ id, ...data }) => ({ url: `${BANK_LOOKUP_URL}/${id}`, method: 'PUT', body: data }),
      invalidatesTags: (res, error, req) => [{ type: ApiTagType.BankLookup, id: req.id }],
    }),
    deleteBankLookup: builder.mutation<void, number>({
      query: (id) => ({ url: `${BANK_LOOKUP_URL}/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: ApiTagType.BankLookup, id: 'LIST' }],
    }),
  }),
});

export const {
  useFetchBankLookupsQuery,
  useCreateBankLookupMutation,
  useUpdateBankLookupMutation,
  useDeleteBankLookupMutation,
} = bankLookupApiSlice;
